<template>
  <el-form :model="params" :rules="rules" ref="params" label-width="100px" class="demo-ruleForm">
    <div class="container h_100_now">
      <el-card class="el_card bg_fff">
        <div slot="header" class="fontSize_14">注册正和港用户</div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">用户名:</div>
            <el-input class="flex_1" v-model="params.username"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*密码:</div>
            <el-input class="flex_1" v-model="params.password"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*再次确认密码:</div>
            <el-input class="flex_1" v-model="params.password_confirm"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*邮箱:</div>
            <el-input class="flex_1" v-model="params.password"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*手机:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*企业名称:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*企业所在地:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*区/县/镇:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item  flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*联系人:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end">*联系电话:</div>
            <el-input class="flex_1" v-model="value"></el-input>
        </div>
        <div class="item flex mb_10">
          <div class="item_left fontSize_14 flex justify_end"></div>
          <el-button class="" type="primary">立即注册</el-button>
        </div>
        <div class="has_account_wrap flex justify_end">
          <el-button type="text">已经有了正和港帐号？立即登录</el-button>
        </div>
      </el-card>
    </div>
  </el-form>
</template>

<script>
export default {
  data(){
    return {
      params: {
        type: 'customer',
      },
    };
  },
}
</script>
<style scoped>
.container{
  background: #606266;
}

.el_card{
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
}

.item_left{
  width: 100px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue